<template>
    <div>
        <div class="about-banner">
             <img :src="serbanner" />
            <div class="about-banner-word">
                <span>专业服务 Professional Services</span>
            </div>
        </div>
        <div class="about-title">
            <span class="fn32">专业服务</span>
        </div>
        <div class="zhuanye-service">
            <a href="javascript:;" v-for="(item,index) in serve_list" :key="index">
                <span><img :src="'../../static/img/'+item.img" /></span>
                <h4>{{item.text}}</h4>
            </a>
        </div>
    </div>
</template>

<script>
 export default {
        name: 'Serve',
        data () {
            return {
                serbanner: require('../assets/img/specialservice.png'),
                sericon: require('../assets/img/business.png'),
                mainimg: require('../assets/img/business.png'),
                menu_active: [
                    {
                        title: '专业服务',
                        link: '',
                        isActive: true,
                    },
                ],
                active: false,
                serve_list: [
                    {
                        img: '1.png',
                        text: '投资管理',
                    },
                    {
                        img: '2.png',
                        text: '项目投资',
                    },
                    {
                        img: '3.png',
                        text: '房地产开发',
                    },
                    {
                        img: '4.png',
                        text: '资产管理',
                    },
                    {
                        img: '5.png',
                        text: '企业管理',
                    },
                    {
                        img: '6.png',
                        text: '物业管理',
                    },
                    {
                        img: '7.png',
                        text: '房地产价格评估',
                    },
                    {
                        img: '8.png',
                        text: '房屋征收',
                    },
                    {
                        img: '1.png',
                        text: '热力供应',
                    },
                    {
                        img: '9.png',
                        text: '清洁服务',
                    },
                    {
                        img: '11.png',
                        text: '承办展览展示活动',
                    },
                ]
            }
        },
        mounted(){

        },
        methods:{
            menuChange: function(tabIndex){
                var that = this;
                var tabCardCollection = document.querySelectorAll(".tab-card"),
                len = tabCardCollection.length;
                for(var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                    that.menu_active[i].isActive = false;
                }
                that.menu_active[tabIndex].isActive = true;
                tabCardCollection[tabIndex].style.display = "block";
            }
        },
        created(){

        },
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/specialtyService.vue